import { put, call, take, fork } from 'redux-saga/effects'
import { getUserLimits } from '../../api/limit'
import {
  userLimitsGetSuccess,
  userLimitsGetError,
} from '../../reducers/user-limits/action'
import { USER_LIMITS_GET } from '../../reducers/user-limits/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* userLimitsGetFlow(payload) {
  try {
    const { callback } = payload
    const response = yield call(getUserLimits)

    yield put(userLimitsGetSuccess(response.data))
    yield put(operationSuccess())

    if (callback) {
      callback(response.data)
    }
  } catch (error) {
    yield put(userLimitsGetError(error))
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* userLimitsGetWatcher() {
  while (true) {
    const action = yield take(USER_LIMITS_GET)
    const { payload } = action

    yield fork(generalSaga, userLimitsGetFlow, payload)
  }
}
